import { forEach } from "lodash";



const RIGHT = "right";
const LEFT = "left";
const BOTH = "both";
const NONE = "none";

document.documentElement.classList.remove("no-js");
document.documentElement.classList.add("js");



var navContainer: NodeListOf<HTMLElement> = document.querySelectorAll("[data-horizontal-scroll-container]");
var navContent: NodeListOf<HTMLElement> = document.querySelectorAll("[data-horizontal-scroll-content]");

// Handle the scroll of the horizontal container
var ticking = false;

export function initializeSubNavScrolling() {
    if (!navContainer || !navContent || navContainer.length < 1 || navContent.length < 1)
        return;
    navContainer.forEach(el => {
        let subNavContainer: HTMLElement = el;
        let subNavContent: HTMLElement = el.querySelector("[data-horizontal-scroll-content]");

        // Out advancer buttons
        var advancerLeft: HTMLElement = el.querySelector("#subNavAdvancerLeft");
        var advancerRight: HTMLElement = el.querySelector("#subNavAdvancerRight");
        let SETTINGS = {
            navBarTravelling: false,
            navBarTravelDirection: "",
            navBarTravelDistance: 150
        }
        setOverflowAttribute(subNavContent, subNavContainer);

        window.addEventListener('resize', function () {
            setOverflowAttribute(subNavContent, subNavContainer);
        });

        subNavContainer.addEventListener("scroll", function () {
            if (!ticking) {
                window.requestAnimationFrame(function () {
                    setOverflowAttribute(subNavContent, subNavContainer);
                    ticking = false;
                });
            }
            ticking = true;
        });


        advancerLeft.addEventListener("click", function () {
            // If in the middle of a move return
            if (SETTINGS.navBarTravelling === true) {
                return;
            }
            // If we have content overflowing both sides or on the left
            if (determineOverflow(subNavContent, subNavContainer) === LEFT || determineOverflow(subNavContent, subNavContainer) === BOTH) {
                // Find how far this panel has been scrolled
                var availableScrollLeft = subNavContainer.scrollLeft;
                // If the space available is less than two lots of our desired distance, just move the whole amount
                // otherwise, move by the amount in the settings
                if (availableScrollLeft < SETTINGS.navBarTravelDistance * 2) {
                    subNavContent.style.transform = getTranslationText(availableScrollLeft);
                } else {
                    subNavContent.style.transform = getTranslationText(SETTINGS.navBarTravelDistance);
                }
                // Update our settings
                SETTINGS.navBarTravelDirection = LEFT;
                SETTINGS.navBarTravelling = true;
            }
        });

        advancerRight.addEventListener("click", function () {
            // If in the middle of a move return
            if (SETTINGS.navBarTravelling === true) {
                return;
            }
            // If we have content overflowing both sides or on the right
            if (determineOverflow(subNavContent, subNavContainer) === RIGHT || determineOverflow(subNavContent, subNavContainer) === BOTH) {
                // Get the right edge of the container and content
                var contentRightEdge = subNavContent.getBoundingClientRect().right;
                var containerRightEdge = subNavContainer.getBoundingClientRect().right;
                // Now we know how much space we have available to scroll
                var availableScrollRight = Math.floor(contentRightEdge - containerRightEdge);

                var styleOfTransform = window.getComputedStyle(subNavContent, null);
                var tr = styleOfTransform.getPropertyValue("-webkit-transform") || styleOfTransform.getPropertyValue("transform");
                var amount = Math.abs(parseInt(tr.split(",")[4]) || 0);
                // If the space available is less than two lots of our desired distance, just move the whole amount
                // otherwise, move by the amount in the settings
                if (availableScrollRight < SETTINGS.navBarTravelDistance * 2) {
                    subNavContent.style.transform = getTranslationText(availableScrollRight + amount);
                } else {
                    subNavContent.style.transform = getTranslationText(SETTINGS.navBarTravelDistance + amount);
                }
                // Update our settings
                SETTINGS.navBarTravelDirection = RIGHT;
                SETTINGS.navBarTravelling = true;
            }
        });

        subNavContent.addEventListener(
            "transitionend",
            function () {
                setOverflowAttribute(subNavContent, subNavContainer);
                SETTINGS.navBarTravelling = false;
            },
            false
        );
    });
    
}

function getTranslationText(value: number) {
    return "translateX(-" + value + "px)";
}

function setOverflowAttribute(content: HTMLElement, container: HTMLElement) {
    container.setAttribute("data-overflowing", determineOverflow(content, container));
}

function determineOverflow(content: HTMLElement, container: HTMLElement) {
    var containerMetrics = container.getBoundingClientRect();
    var containerMetricsRight = Math.floor(containerMetrics.right);
    var containerMetricsLeft = Math.floor(containerMetrics.left);
    var contentMetrics = content.getBoundingClientRect();
    var contentMetricsRight = Math.floor(contentMetrics.right);
    var contentMetricsLeft = Math.floor(contentMetrics.left);
    if (containerMetricsLeft > contentMetricsLeft && containerMetricsRight < contentMetricsRight) {
        return BOTH;
    } else if (contentMetricsLeft < containerMetricsLeft) {
        return LEFT;
    } else if (contentMetricsRight > containerMetricsRight) {
        return RIGHT;
    } else {
        return NONE;
    }
}